import { getMovementsEndpoint } from 'services/movements/movements.config';
import { BillOperations, LitPlayList, Movement } from './movements.types';

/**
 * Returns 'true' if the input string is a resourceId of
 * 'getWithdrawalCredentials'.
 * @param resourceId
 */
export function isGetMovementsResourceId(resourceId: string): boolean {
  return resourceId.startsWith(getMovementsEndpoint);
}

/**
 * Returns a sorted descending list.
 * @see getLitPlayList
 */
export function litPlayListComparator(playA: LitPlayList, playB: LitPlayList) {
  return playB.order - playA.order;
}

/**
 * Returns a sorted descending list.
 * @see getMovements
 */
export function movementsComparator(movA: Movement, movB: Movement) {
  return movB.order - movA.order;
}

/**
 * Returns a sorted descending list.
 * @see getBookingOperations
 */
export function billOperationsComparator(
  operA: BillOperations,
  operB: BillOperations,
) {
  return operB.order - operA.order;
}
